/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  GetActiveLanguagesQueryResponse,
  GetActiveLanguagesPathParams,
} from "../types/GetActiveLanguages.ts"

export const getActiveLanguagesQueryKey = (
  productSheetGroupId: GetActiveLanguagesPathParams["productSheetGroupId"]
) =>
  [
    {
      url: "/v1/organization-settings/get-active-languages/:productSheetGroupId",
      params: { productSheetGroupId },
    },
  ] as const

export type GetActiveLanguagesQueryKey = ReturnType<
  typeof getActiveLanguagesQueryKey
>

/**
 * @summary Get active languages by productSheetGroup
 * {@link /v1/organization-settings/get-active-languages/:productSheetGroupId}
 */
export async function getActiveLanguages(
  productSheetGroupId: GetActiveLanguagesPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetActiveLanguagesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-active-languages/${productSheetGroupId}`,
    ...requestConfig,
  })
  return res
}

export function getActiveLanguagesQueryOptions(
  productSheetGroupId: GetActiveLanguagesPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getActiveLanguagesQueryKey(productSheetGroupId)
  return queryOptions<
    ResponseConfig<GetActiveLanguagesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetActiveLanguagesQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productSheetGroupId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getActiveLanguages(productSheetGroupId, config)
    },
  })
}

/**
 * @summary Get active languages by productSheetGroup
 * {@link /v1/organization-settings/get-active-languages/:productSheetGroupId}
 */
export function useGetActiveLanguages<
  TData = ResponseConfig<GetActiveLanguagesQueryResponse>,
  TQueryData = ResponseConfig<GetActiveLanguagesQueryResponse>,
  TQueryKey extends QueryKey = GetActiveLanguagesQueryKey,
>(
  productSheetGroupId: GetActiveLanguagesPathParams["productSheetGroupId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetActiveLanguagesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? getActiveLanguagesQueryKey(productSheetGroupId)

  const query = useQuery(
    {
      ...getActiveLanguagesQueryOptions(productSheetGroupId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
